// Backend API URL — set via REACT_APP_API_URL env var at build time.
// Falls back to production URL if not set.
export const BACKEND_API_URL = process.env.REACT_APP_API_URL || 'https://platformopslab.com/api/v1/';

// Backend IP address — set via REACT_APP_BACKEND_IP env var at build time.
export const BACKEND_IP_ADDRESS = process.env.REACT_APP_BACKEND_IP || 'platformopslab.com';

// Google OAuth client ID — set via REACT_APP_GOOGLE_CLIENT_ID env var at build time.
// Falls back to empty string (Google login disabled) if not set.
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
